import Handlebars from 'injectify/runtime';

Handlebars.registerHelper('windSpeedUnit', function () {
    const mapping = {
        MPS: __('SPEED_UNIT_STRING.MPS'),
        default: __('SPEED_UNIT_STRING'),
    };

    return mapping[__('_WIND_SPEED_UNIT')] || mapping.default;
});



// WEBPACK FOOTER //
// ./shared/helper/units.js